<mat-card
  [ngClass]="senderId === currentUserId ? 'sendMsg' : 'receivedMsg'"
  class="card-container"
  appReadonly
  data-testid="field_message">
  <mat-card-header>
    <mat-icon (click)="onClose()" svgIcon="xmark" class="close-icon" style="cursor: pointer"></mat-icon>
    <mat-card-subtitle class="response-sender">
      {{ sender }}
      <span class="date">
        @if (DateUtils.isToday(date)) {
          Heute {{ date | date: 'shortTime' }}:
        } @else {
          {{ date | date: 'short' }}:
        }
      </span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="msg-content" data-testid="field_reply_content">
    @if (body || formattedBody) {
      @switch (msgtype) {
        @case (MsgType.Text) {
          @if (formattedBody) {
            @if (formattedBody.includes('data-mx-spoiler')) {
              @for (chunk of formattedBody | spoilerChunks; track chunk) {
                @if (chunk.isSpoiler) {
                  <app-spoiler [content]="chunk.content" [preview]="true"></app-spoiler>
                } @else {
                  <span class="clamp-text" [innerHTML]="chunk.content"></span>
                }
              }
            } @else {
              <span class="clamp-text" [innerHTML]="formattedBody"></span>
            }
          } @else {
            <span class="clamp-text" [innerHTML]="body"></span>
          }
        }
        @default {
          @if (fileName || fileSize) {
            <button
              class="file-button file-border"
              [attr.data-testid]="testIds.linkDownloadfile"
              mat-button
              tabindex="0"
              disabled>
              <div class="file-actions">
                @let fileIcon = getFileTypeIcon(fileName);
                @if (fileIcon) {
                  <mat-icon svgIcon="{{ getFileTypeIcon(fileName) || 'file' }}"></mat-icon>
                }
                <span class="clamp-text file-name-button">{{ fileName }}</span>
                <span>({{ formatFileSize(fileSize) }})</span>
              </div>
            </button>
            @if (formattedBody) {
              <div class="caption" style="margin-top: 8px">
                <span class="clamp-text" [innerHTML]="formattedBody" appCustomLink></span>
              </div>
            }
          } @else {
            <span class="clamp-text" [innerHTML]="formattedBody || body" appCustomLink></span>
          }
        }
      }
    }
  </mat-card-content>
</mat-card>
